<template>
  <div class="theme-page">
    <empty-data v-if="themesList.length <= 0" emptyMsg="暂无任何主题内容"></empty-data>
    <div class="theme-lists" v-else>
      <p class="theme-title">我的主题</p>
      <el-table
        :data="themesList"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableColClassName"
        :header-row-style="{fontSize: '16px',color: '#333' }"
        :header-cell-class-name="tableColClassName"
        :highlight-current-row="true"
      >
        <el-table-column
          v-for="titleItem in tableTitleInfo"
          :key="titleItem.key"
          :prop="titleItem.prop"
          :label="titleItem.label"
          :align="titleItem.align"
          :width="titleItem.width"
        >
          <template slot-scope="scope">
            <div v-if="titleItem.prop === 'status'" class="live-status row-cont"  @click="toThemeDetail(scope.row.themeId)">
              <p v-if="scope.row.status === 2 || scope.row.status === 3" class="">
                <span>正在直播</span>
                <i></i>
              </p>
              <p v-if="scope.row.status === 1">
                {{ scope.row.statusTime}}直播
              </p>
            </div>
            <div v-else-if="titleItem.prop === 'distinguish'" class="opera-btns row-cont">
              <el-button
                @click="handleOperationNotice(scope.row.themeId)"
                type="text"
                size="small"
              >通知</el-button>
              <!-- <el-button type="text" size="small" @click="toThemeDetail(scope.row.themeId)">详情</el-button> -->
              <el-button
                @click="handleOperationThemt(scope.row.themeId, 1)"
                type="text"
                size="small"
              >退出</el-button>
              <el-button
                @click="handleOperationThemt(scope.row.themeId, 0)"
                type="text"
                size="small"
                v-if="scope.row[titleItem.prop] === 0"
              >删除</el-button>
            </div>
            <div class="row-cont" v-else @click="toThemeDetail(scope.row.themeId)">{{ scope.row[titleItem.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <Pages :pageInfo="pageInfo" @handleCurrentChange="handleCurrentChange" />
    </div>
    <Notice
      v-if="showCreateNotice"
      :id="noticeThemeId"
      add-type="theme"
      :showDialog="showCreateNotice"
      @close="showCreateNotice=false"
    ></Notice>
  </div>
</template>

<script>
import { getThemesListApi, deleteThemeApi } from '@/api/plantform/theme'
import EmptyData from '../../components/plantFormCommon/empty'
import { $Cookies, checkUserAuthApi } from '@/utils/index'
import { Pages, Notice } from '@/components/plantFormDialogs'

export default {
  name: "myTheme",
  components: {
    Pages,
    EmptyData,
    Notice,
  },
  data() {
    return {
      themesList: [], // 主题列表
      tableTitleInfo: [ // 表头配置信息
        { prop: 'themeName', label: '主题名称', width: '420', key: 'title', align: 'left' },
        { prop: 'status', label: '', width: '130', key: 'status', align: 'left' },
        { prop: 'createTime', label: '创建时间', width: '210', key: 'time', align: 'left' },
        { prop: 'distinguish', label: '操作', width: '170', key: 'opera', align: 'left' },
      ],
      pageInfo: { //分页传参
        pageNum: 0,
        total: 0,
        pageSize: 10
      },
      showCreateNotice: false,
      noticeThemeId: 0,
    }
  },
  created() {
    this.pageInfo.total = this.themesList.length;
    // 获取主题列表
    this._getThemesListApi()
  },
  mounted() {
    this.$bus.$on('handleUpdateTheme', () => {
      this.handleUpdateTheme()
    })
  },
  methods: {
    // 创建主题
    handleUpdateTheme() {
      this.pageInfo = {
        pageNum: 0,
        total: 0,
        pageSize: 10
      }
      this._getThemesListApi()
    },

    // 删除、退出主题
    async handleOperationThemt(themeId, type) {

      const checkType = type === 1 ? 'quitTheme' : 'deleteTheme'
      const hasPermissions = await checkUserAuthApi(checkType, themeId)
      if (!hasPermissions) return

      this.$confirm('此操作将' + (type === 1 ? '退出' : '删除') + '该主题，是否继续？', {
        type: 'warning'
      }).then(() => {
        this._deleteOrExitTheme(themeId, type)
      }).catch(() => { })
    },

    // 跳转至主题详情页
    toThemeDetail(id) {
      this.$router.push('/plantForm/themeDetail/' + id)
    },

    // 表格行样式
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'table-list__row row-has_bgc' : 'table-list__row'
    },

    // 表格列样式
    tableColClassName({ columnIndex }) {
      return columnIndex === 0 ? 'pl20' : ''
    },

    // 获取我的主题列表
    _getThemesListApi() {
      const uid = $Cookies.get('uid')
      getThemesListApi({
        uid,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      }).then(res => {
        if (res.success) {
          this.themesList = res.result.list
          this.pageInfo.total = res.result.total
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    // 删除 或 退出 主题
    _deleteOrExitTheme(themeId, distinguish) {
      const uid = $Cookies.get('uid')
      deleteThemeApi({
        uid,
        distinguish,
        themeId
      }).then(res => {
        if (res.success) {
          this.$message.success({
            message: distinguish === 0 ? '删除成功' : '已退出主题',
            duration: 2000,
            onClose: () => {
              this.pageInfo = {
                pageNum: 0,
                total: 0,
                pageSize: 10
              }
              this._getThemesListApi()
            }
          })
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },

    // 翻页
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val;
      this._getThemesListApi();
    },

    async handleOperationNotice(themeId) {
      const hasPermissions = await checkUserAuthApi('themeNotice', themeId)
      if (!hasPermissions) return

      this.noticeThemeId = themeId
      this.showCreateNotice = true
    }
  }
}
</script>
